module.exports = __webpack_public_path__ + "img/new-logo-64.7cdbebf.png";